import script from "./GlobalToast.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalToast.vue?vue&type=script&setup=true&lang=js"

import "./GlobalToast.vue?vue&type=style&index=0&id=7b6b6976&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b6b6976"]])

export default __exports__